/**
 * Configuración centralizada de límites de exportación para listados.
 *
 * Cada ámbito (exportScope) se mapea a:
 * - envKey: clave de window._env_ (variable de entorno inyectada en runtime)
 * - fallback: valor por defecto si la variable no está definida
 */

export const ListExportScope = {
  SHIPMENT_LIST: "SHIPMENT_LIST",
  ALARMS: "ALARMS",
};

const exportConfig = {
  [ListExportScope.SHIPMENT_LIST]: {
    envKey: "REACT_APP_MAX_EXPORT_SHIPMENTLIST",
    fallback: 500,
  },
  [ListExportScope.ALARMS]: {
    envKey: "REACT_APP_MAX_EXPORT_ALARMS",
    fallback: 500,
  },
};

/**
 * Obtiene el límite máximo de exportación para un scope dado.
 * @param {string} exportScope - Identificador del ámbito de exportación (ListExportScope)
 * @returns {number} Límite máximo de registros exportables
 */
export function getExportMaxLimit(exportScope) {
  const config = exportConfig[exportScope];

  if (!config) {
    console.warn(
      `[listExportMaxConfig] Scope desconocido: "${exportScope}". Usando fallback de 500.`,
    );
    return 500;
  }

  const envValue = window._env_?.[config.envKey];
  const parsed = Number(envValue);

  return Number.isNaN(parsed) || parsed <= 0 ? config.fallback : parsed;
}

export default exportConfig;
